// Writes your routes here
// Product Category
export const categoryListApi = 'configuration/product-category/list'
export const categoryStoreApi = 'configuration/product-category/store'
export const categoryUpdateApi = 'configuration/product-category/update'
export const categoryToggleStatusApi = 'configuration/product-category/toggle-status'
export const categoryDestroyApi = 'configuration/product-category/destroy'

// Product Sub Category
export const subCategoryListApi = 'configuration/products-sub-category/list'
export const subCategoryStoreApi = 'configuration/products-sub-category/store'
export const subCategoryUpdateApi = 'configuration/products-sub-category/update'
export const subCategoryToggleStatusApi = 'configuration/products-sub-category/toggle-status'
export const subCategoryDestroyApi = 'configuration/products-sub-category/destroy'

// Product Unit Info
export const unitInfoListApi = 'configuration/unit-info/list'
export const unitInfoStoreApi = 'configuration/unit-info/store'
export const unitInfoUpdateApi = 'configuration/unit-info/update'
export const unitInfoToggleStatusApi = 'configuration/unit-info/toggle-status'
export const unitInfoDestroyApi = 'configuration/unit-info/destroy'

// Product Name Info
export const productNameListApi = 'configuration/product-name/list'
export const productNameStoreApi = 'configuration/product-name/store'
export const productNameUpdateApi = 'configuration/product-name/update'
export const productNameToggleStatusApi = 'configuration/product-name/toggle-status'
export const productNameDestroyApi = 'configuration/product-name/destroy'

// Factory Info
export const factoryInfoListApi = 'configuration/factory-info/list'
export const factoryInfoStoreApi = 'configuration/factory-info/store'
export const factoryEntryUpdateApi = 'configuration/factory-info/update'
export const factoryInfoToggleStatusApi = 'configuration/factory-info/toggle-status'

// Vehicle Info
export const vehicleInfoListApi = 'configuration/vehicle-info/list'
export const vehicleInfoStoreApi = 'configuration/vehicle-info/store'
export const vehicleEntryUpdateApi = 'configuration/vehicle-info/update'
export const vehicleInfoToggleStatusApi = 'configuration/vehicle-info/toggle-status'

// SalesCenterInfo
export const SalesCenterInfoList = '/configuration/sales-center-info/list'
export const SalesCenterInfoStore = '/configuration/sales-center-info/store'
export const SalesCenterInfoUpdate = '/configuration/sales-center-info/update'
export const SalesCenterInfoStatus = '/configuration/sales-center-info/toggle-status'
export const SalesCenterInfoDestroy = '/configuration/sales-center-info/destroy'

// Case Mapping
export const caseMappingListApi = 'configuration/case-mapping/list'
export const caseMappingStoreApi = 'configuration/case-mapping/store'
export const caseMappingUpdateApi = 'configuration/case-mapping/update'
export const caseMappingToggleStatusApi = 'configuration/case-mapping/toggle-status'

// Promotion Type
export const PromotionTypeList = '/configuration/promotion-type/list'
export const PromotionTypeStore = '/configuration/promotion-type/store'
export const PromotionTypeUpdate = '/configuration/promotion-type/update'
export const PromotionTypeStatus = '/configuration/promotion-type/toggle-status'
export const PromotionTypeDestroy = '/configuration/promotion-type/destroy'

// dealerRetailerInfo
export const dealerRetailerInfoList = '/configuration/dealer-retailer-info/list'
export const dealerRetailerInfoShow = '/configuration/dealer-retailer-info/show'
export const dealerRetailerInfoStore = '/configuration/dealer-retailer-info/store'
export const dealerRetailerInfoFind = '/configuration/dealer-retailer-info/find'
export const dealerRetailerInfoUpdate = '/configuration/dealer-retailer-info/update'
export const dealerRetailerInfoStatus = '/configuration/dealer-retailer-info/toggle-status'
export const dealerRetailerInfoDestroy = '/configuration/dealer-retailer-info/destroy'

// Designation Info
export const designationListApi = 'configuration/designation-info/list'
export const designationStoreApi = 'configuration/designation-info/store'
export const designationUpdateApi = 'configuration/designation-info/update'
export const designationToggleStatusApi = 'configuration/designation-info/toggle-status'

// User Info
export const userInfoListApi = 'configuration/user-info/list'
export const userInfoStoreApi = 'configuration/user-info/store'
export const userInfoUpdateApi = 'configuration/user-info/update'
export const userInfoToggleStatusApi = 'configuration/user-info/toggle-status'
// price Info
export const priceInfoList = 'configuration/price-info/list'
export const priceInfoStore = 'configuration/price-info/store'
export const priceInfoUpdate = 'configuration/price-info/update'
export const priceInfoToggleStatus = 'configuration/price-info/toggle-status'
export const getPriceById = 'configuration/price-info/get-price-by-id'
// Report Heading
export const reportHeadingList = 'configuration/report-heading/list'
export const reportHeadingStore = 'configuration/report-heading/store'
export const reportHeadingUpdate = 'configuration/report-heading/update'
export const reportHeadingDetail = 'configuration/report-heading/detail'
export const reportToggleStatus = 'configuration/report-heading/toggle-status'

// Supplier Info
export const supplierInfoList = '/configuration/supplier-info/list'
export const supplierInfoShow = '/configuration/supplier-info/show'
export const supplierInfoStore = '/configuration/supplier-info/store'
export const supplierInfoUpdate = '/configuration/supplier-info/update'
export const supplierInfoToggleStatus = 'configuration/supplier-info/toggle-status'

// security-money
export const securityMonyListApi = 'configuration/security-money/list'
export const securityMonyStoreApi = 'configuration/security-money/store'
export const securityMonyUpdateApi = 'configuration/security-money/update'
export const securityMonyToggleStatusApi = 'configuration/security-money/toggle-status'
export const securityMonyDestroyApi = 'configuration/security-money/destroy'
export const fiscalYearData = 'master-fiscal-year/show'

export const notificationReceivedList = '/notification-received/list'
